import { defineStore } from 'pinia'
import { authStore } from '@/stores/auth'

// Whether the signed-in user may use ADAS IQ, so the portal only offers it to them.
// ADAS IQ's own /v1/access answers (the Launchpad ADAS Map Mobile flag, the same check
// the embedded chat makes); anything but a 200 counts as no. Asked once per page load
// and per token: a grant or revocation shows on the next load.
export const adasIqStore = defineStore('adasIq', {
  state: () => ({
    allowed: false,
    checkedToken: null,
    pending: null
  }),
  actions: {
    async check() {
      const token = authStore().token
      const base = window.config && window.config.adasIqUrl ? String(window.config.adasIqUrl).replace(/\/+$/, '') : ''
      if (!base || !token) {
        this.allowed = false
        return false
      }
      if (this.checkedToken === token) {
        return this.pending ? await this.pending : this.allowed
      }
      this.checkedToken = token
      this.pending = fetch(`${base}/v1/access`, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.ok)
        .catch(() => false)
      const allowed = await this.pending
      // A newer token started its own check meanwhile; that one decides.
      if (this.checkedToken === token) {
        this.allowed = allowed
        this.pending = null
      }
      return allowed
    }
  }
})
